import { render, staticRenderFns } from "./VocationIntroSection.vue?vue&type=template&id=0bba355b"
import script from "./VocationIntroSection.vue?vue&type=script&lang=ts"
export * from "./VocationIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./VocationIntroSection.vue?vue&type=style&index=0&id=0bba355b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports